module.exports = __webpack_public_path__ + "img/budget-hover.cc3045b7.png";